import React, { createContext, useContext, useEffect, useState } from "react";
import config from "../config";

// Textos editáveis no BO (Textos do Site), vindos de /api/textos como { id: valor }
const TextosContext = createContext({ textos: {}, loaded: true });

export const TextosProvider = ({ children }) => {
  const [textos, setTextos] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let ativo = true;

    fetch(`${config.baseURL}/api/textos`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (ativo && data && typeof data === "object") setTextos(data);
      })
      .catch((error) => console.error("Erro ao carregar textos:", error))
      .finally(() => ativo && setLoaded(true));

    return () => {
      ativo = false;
    };
  }, []);

  return (
    <TextosContext.Provider value={{ textos, loaded }}>
      {children}
    </TextosContext.Provider>
  );
};

/**
 * const t = useTextos();
 * t("historia.titulo", "HISTÓRIA")
 *
 * Devolve o texto definido no BO ou, se não existir, o texto por defeito.
 * Enquanto os textos carregam devolve um espaço (evita mostrar o texto antigo e depois trocar).
 */
export const useTextos = () => {
  const { textos, loaded } = useContext(TextosContext);

  return (id, fallback = "") => {
    if (!loaded) return " ";
    const valor = textos[id];
    return typeof valor === "string" && valor.trim() !== "" ? valor : fallback;
  };
};
